import { render, staticRenderFns } from "./ProfileHome.vue?vue&type=template&id=b6a8718c&"
import script from "./ProfileHome.vue?vue&type=script&lang=js&"
export * from "./ProfileHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports